import { useState } from 'react';
import { useEffectOnce } from 'react-use';

const THROTTLE_TIME = 5000;

export interface TimeIntervalRefreshAds {
  hasChangedPhoto: boolean;
  hasFiveSecondsPassed: boolean;
  refreshAdThrottled: () => void;
  registerAd: (id: string) => void;
  onRefresh: (id: string) => void;
}

export default function useRefresh(): TimeIntervalRefreshAds {
  const [hasChangedPhoto, setHasChangedPhoto] = useState<boolean>(false);
  const [hasFiveSecondsPassed, setHasFiveSecondsPassed] = useState<boolean>(false);
  const adsRerender: { [id: string]: boolean } = {};

  useEffectOnce(() => {
    const timeout = setTimeout(() => {
      setHasFiveSecondsPassed(true);
    }, THROTTLE_TIME);
    return (): void => clearTimeout(timeout);
  });

  function refreshAdThrottled(): void {
    if (hasFiveSecondsPassed) setHasChangedPhoto(true);
  }

  function registerAd(id: string): void {
    adsRerender[id] = false;
  }

  function onAllRefreshed(): void {
    setHasChangedPhoto(false);
    setHasFiveSecondsPassed(false);
    setTimeout(() => {
      setHasFiveSecondsPassed(true);
    }, THROTTLE_TIME);
  }

  function onRefresh(id: string): void {
    adsRerender[id] = true;

    const allRerendered = Object.values(adsRerender).every(
      (rerender: boolean) => rerender === true
    );

    if (allRerendered) {
      Object.keys(adsRerender).forEach((key) => {
        adsRerender[key] = false;
      });
      onAllRefreshed();
    }
  }

  return { refreshAdThrottled, registerAd, onRefresh, hasChangedPhoto, hasFiveSecondsPassed };
}
